module.exports = __webpack_public_path__ + "static/media/video-virtual-showroom.8be93a2b.mp4";